import type {
  PersonProfileLite,
  PersonProfile,
} from '@openeducation/oe-rn-shared-types';
import axios from 'axios';

import type { Environment } from '../interfaces';
import { hostsConfig } from '../utils/hosts-config';

export default abstract class PersonProfileDao {
  static async getProfileById(env: Environment, personId: number) {
    const url = hostsConfig[env].wolverineServiceUrl;

    const { data } = await axios.get<PersonProfile>(
      `${url}/profile/person/${personId}`
    );

    return data;
  }

  static async getLiteProfileById(env: Environment, personId: number) {
    const url = hostsConfig[env].profileServiceUrl;
    const { data } = await axios.get<PersonProfileLite>(
      `${url}/v1/profile/person/lite/${personId}`
    );
    return data;
  }

  static async getProfileAvatar(
    env: Environment,
    personId: number,
    size = 50
  ): Promise<string> {
    const url = `${hostsConfig[env].wolverineServiceUrl}/images/image/${personId}/${size}/${size}`;
    const { data } = await axios.get(url);

    return data;
  }
}
